export function slugify(str: string | undefined) {
  if (!str) return "";

  return str
    .toLowerCase()
    .trim()
    .replace(/[^\u4e00-\u9fa5\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
